import type { ViewState } from '../types/warehouse.types';

/**
 * Convert screen coordinates to world coordinates
 */
export const screenToWorld = (
  screenX: number,
  screenY: number,
  viewState: ViewState,
  canvasWidth: number,
  canvasHeight: number
): { x: number; y: number } => {
  const { offsetX, offsetY, scale, rotation } = viewState;

  // Reverse the transformations from worldToScreen
  const pivotX = (canvasWidth / 2) / scale;
  const pivotY = (canvasHeight / 2) / scale;

  // Unscale
  const scaledX = screenX / scale;
  const scaledY = screenY / scale;

  // Rotate back (inverse rotation)
  const cos = Math.cos(-rotation);
  const sin = Math.sin(-rotation);

  const pointRelativeToPivotX = scaledX - pivotX;
  const pointRelativeToPivotY = scaledY - pivotY;

  const rotatedX = pointRelativeToPivotX * cos - pointRelativeToPivotY * sin;
  const rotatedY = pointRelativeToPivotX * sin + pointRelativeToPivotY * cos;

  const worldX = rotatedX + pivotX - offsetX;
  const worldY = rotatedY + pivotY - offsetY;

  return { x: worldX, y: worldY };
};
